export default "__VITE_ASSET__C6lgGhW7__"